<template>
  <div class="admin">

    <div class="admin-area">

      <div class="row row-gutter-20">
        <div class="col-6">
          <admin-nav></admin-nav>
        </div>
        <div class="col-18">

          <header class="admin-header cf">
            <ul class="nav nav-header cf">
              <li><router-link to="/admin/vehicle_makes">Marken</router-link></li>
              <li>{{ vehicle_make.name }}</li>
            </ul>
            <div class="header-actions">
              <p><router-link to="/admin/vehicle_makes" class="button button-grey button-small">Alle Marken ›</router-link></p>
            </div>
          </header>

          <form @submit="update_vehicle_make" class="form" method="post" style="margin-top:20px">

            <div class="form-wrap">
              <label for="name">Name</label>
              <input v-model="vehicle_make.name" class="form-input" type="text" name="name" id="name" placeholder="Name">
            </div>

            <p v-if="vehicle_make.logo"><img :src="vehicle_make.logo" width="200"></p>

            <div class="form-wrap">
              <label>Logo</label>
              <input type="file" @change="set_logo">
            </div>

            {{ errors }}

            <p>
              <input type="submit" value="Speichern ›" class="button button-orange button-small">
            </p>


          </form>


        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import AdminNav from '../../../components/admin_nav'

export default {
  name: 'admin_reservations',
  components: {
    AdminNav
  },
  data () {
    return {
      errors: [],
      vehicle_make: {
        name: "",
        logo: ""
      },
      temp_logo: ""
    }
  },
  methods: {
    get_data() {

      axios.get(process.env.VUE_APP_BASE_API+'/v1/admin/vehicle_makes/'+this.$route.params.id, { headers: { Authorization: this.$store.getters.getToken }})
      .then(response => {
        console.log(response);
        this.vehicle_make = response.data.vehicle_make;
      })
      .catch(error => {
        console.log(error);
      })

    },
    update_vehicle_make: function (e) {
      e.preventDefault();

      var form_data = new FormData();
      form_data.append("name", this.vehicle_make.name);
      form_data.append("logo", this.temp_logo);

      axios.patch(process.env.VUE_APP_BASE_API+'/v1/admin/vehicle_makes/'+this.$route.params.id, form_data, { headers: { Authorization: this.$store.getters.getToken }})
      .then(response => {
        console.log(response);
        this.$router.push('/admin/vehicle_makes');
      })
      .catch(error => {
        this.errors = error.response.data.errors;
      })

    },
    set_logo(event) {
      this.temp_logo = event.target.files[0];
    }
  },
  mounted () {
    this.get_data();
  }
}
</script>

<style lang="scss">

</style>
